import application from 'application/application';

//Formata o numero para o padrão CNJ -> 0000000-00.0000.0.00.0000
application.filter('formatToCNJ', function() {
	return function(input) {
		if (input && input.length == 20 && !isNaN(input)) {
			return input.replace(
				/(\d{7})(\d{2})(\d{4})(\d{1})(\d{2})(\d{4})/,
				'$1-$2.$3.$4.$5.$6'
			);
		} else {
			return input;
		}
	};
});

application.filter('maskToCNJ', function() {
	return function(value) {
		function transform(value) {
			if (!value) return '';

			// equivalente ao .padStart(20, '0') (mais compatível)
			const digits = String(value).replace(/\D/g, '');
			const padded = digits.padStart
				? digits.padStart(20, '0')
				: ('00000000000000000000' + digits).slice(-20);

			// CNJ: NNNNNNN-DD.AAAA.J.TR.OOOO
			return `${padded.slice(
				0,
				7
			)}-${padded.slice(7, 9)}.${padded.slice(9, 13)}.${padded.slice(13, 14)}.${padded.slice(14, 16)}.${padded.slice(16, 20)}`;
		}

		return transform(value);
	};
});
